import { Modal } from "../../../components/others/Modal/index";
import DangerousZoneAlertContent from "./dangerousZoneAlert";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  onClose?: Function
};

const DangerousZoneAlert = ({ toggleModal, urlTittle, onClose }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";

  return (
    <>
      <Modal
        show={toggleModal}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={() => onClose?.()}
      >
        <DangerousZoneAlertContent
          onClose={() => onClose?.()}
        />
      </Modal>
    </>
  );
};

export default DangerousZoneAlert;
